module.exports = __webpack_public_path__ + "img/South Africa.36770dcb.png";